export const engagementAppGroupIdCampaignCountryPerformanceCampaignId =
  "/engagement/:app_group_id/campaign_country_performance/:campaign_id";
